import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';
import { ExcelService } from '../../../../services/infrastructure/excel.service';
import { LoaderService } from '../../../../services/infrastructure/loader.service';
import { CppReportService } from './../../../../services/cpp/cpp-report.service';
import { Router } from '@angular/router';
import { ColumnDescription, UserReportFilter } from '../../../../models/user-report-filter.model';
import { UserReportFilterSliderService } from '../../../../common/components/user-report-filter/user-report-filter-slider.service';
import { ToastrService } from 'ngx-toastr';
import { UserReportFilterService } from '../../../../services/seed/reports/user-report-filter.service';
import { UserFilterColumnDisplayed } from '../../../../models/user-filter-columndisplayed.model';
import { ReportType } from '../../../../models/report-type.model';

@Component({
  selector: 'app-cpp-ams-pricing',
  templateUrl: './cpp-ams-pricing.component.html',
  styleUrls: ['./cpp-ams-pricing.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class CppAMSPricingComponent implements OnInit, OnDestroy {
  subscription = new Array<Subscription>();
  AMSPricingListDataSource: MatTableDataSource<any>;
  currentFilter = new UserReportFilter();
  filterValueList = new Array();
  branchPlantData: any = [];
  stateData: any = [];
  AMSPricingList: any = [];
  FilteredData: any = [];
  searchbranchPlant = '';
  searchstate = '';
  UpdateTimestamp: any;
  fixedColumn: string[] = ['state', 'branchPlant'];

  originalDisplayedColumns: Array<ColumnDescription> = [
    { columnfield: 'state', headertxt: 'State' },
    { columnfield: 'branchPlant', headertxt: 'Branch Plant' },
    { columnfield: 'secondItemNumber', headertxt: 'Item Number' },
    { columnfield: 'itemDesc', headertxt: 'Item Description' },
    { columnfield: 'itemDesc2', headertxt: 'Package Size' },
    { columnfield: 'price', headertxt: 'Price' }
  ];

  displayedColumns: string[] = this.originalDisplayedColumns.map(x => x.columnfield);

  filteredValues = {
    secondItemNumber: '',
    itemDesc: '',
    state: null,
    branchPlant: null,
  };

  constructor(private CppReportService: CppReportService,
    private loaderService: LoaderService,
    private excelService: ExcelService,
    private router: Router,
    private toastrService: ToastrService,
    private userReportFilterSliderService: UserReportFilterSliderService,
    private userReportFilterService: UserReportFilterService) {
  }

  ngOnInit() {
    this.subscription.push(
      this.userReportFilterSliderService.selectedUserFilter.subscribe(filter => {
        if (filter && filter.reportFilter) {
          const filters: UserFilterColumnDisplayed = JSON.parse(filter.reportFilter);
          if (filter.reportTypeId === ReportType.AMSPricing) {
            this.currentFilter = filter;
            this.displayedColumns = [];
            this.displayedColumns.push('state', 'branchPlant'); //Fixed column for Grid
            filters.displayedColumns.forEach(x => {
              this.displayedColumns.push(x.columnfield);
            });
            this.filteredValues = filters.filterOption;
            this.searchbranchPlant = this.filteredValues['branchPlant'] == null ? [] : this.filteredValues['branchPlant'];
            this.searchstate = this.filteredValues['state'] == null ? [] : this.filteredValues['state'];
            this.filterRecords()
            this.AMSPricingListDataSource.filter = JSON.stringify(this.filteredValues);
          }
          else {
            this.currentFilter = new UserReportFilter();
          }
        }
        else {
          if ((filter && filter.reportTypeId === ReportType.AMSPricing
            && filter.filterDescription === this.currentFilter.filterDescription)
            || !filter) {
            this.displayedColumns = this.originalDisplayedColumns.map(x => x.columnfield);
            this.currentFilter = new UserReportFilter();
            this.filteredValues = {
              secondItemNumber: '',
              itemDesc: '',
              state: null,
              branchPlant: null,
            };
            this.searchbranchPlant = '';
            this.searchstate = '';
            this.filterRecords();
          }
        }
      }));

    this.getAmsPricing();
  }

  customFilterPredicate() {
    const myFilterPredicate = function (data: CppAMSPricingElement, filter: string): boolean {
      const searchString = JSON.parse(filter);
      const itemNumberFound = data.secondItemNumber == null || data.secondItemNumber.toString().trim().indexOf(searchString.secondItemNumber) !== -1;
      const itemDescFound = data.itemDesc == null || data.itemDesc.toString().trim().toLowerCase().indexOf(searchString.itemDesc.toLowerCase()) !== -1;
      return itemNumberFound && itemDescFound;
    };
    return myFilterPredicate;
  }

  // Get Cpp orders list
  getAmsPricing() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.push(this.CppReportService.getAMSPricingReportData().subscribe(result => {
      this.AMSPricingList = result.result;
      this.branchPlantData = result.branchPlantDistinct.filter((thing, i, arr) => arr.findIndex(x => x.branchPlant === thing.branchPlant && x.branchPlant != null) === i);
      this.stateData = result.stateDistinct.filter((thing, i, arr) => arr.findIndex(x => x.state === thing.state && x.state != null) === i);
      this.UpdateTimestamp = result.updateTimestamp[0];
      this.FilteredData = this.AMSPricingList;
      this.AMSPricingListDataSource = new MatTableDataSource(this.AMSPricingList);
      this.AMSPricingListDataSource.filterPredicate = this.customFilterPredicate();
      this.selectAllForDropdownItemsForBranchPlant(this.branchPlantData);
      this.selectAllForDropdownItemsForState(this.stateData);
      this.loaderService.setLoaderStatus(false);
    }, error => { this.loaderService.setLoaderStatus(false); }));
  }

  // Filter the records on basis of account number
  filterRecords() {
    if (this.searchbranchPlant.length > 0 && this.searchstate.length > 0) {
      let filterBranchPlant: any = [];
      filterBranchPlant = this.AMSPricingList.filter(x => { for (const filter of this.searchbranchPlant) { if (x.branchPlant == filter) { return true; } } });
      const filteredStateList = filterBranchPlant.filter(x => { for (const filter of this.searchstate) { if (x.state == filter) { return true; } } });
      this.AMSPricingListDataSource = new MatTableDataSource(filteredStateList);
      this.FilteredData = filteredStateList;
    }
    else if (this.searchbranchPlant.length > 0 && this.searchstate.length == 0) {
      let filterBranchPlant: any = [];
      filterBranchPlant = this.AMSPricingList.filter(x => { for (const filter of this.searchbranchPlant) { if (x.branchPlant == filter) { return true; } } });
      this.AMSPricingListDataSource = new MatTableDataSource(filterBranchPlant);
      this.FilteredData = filterBranchPlant;
      this.stateData = filterBranchPlant.filter((thing, i, arr) => arr.findIndex(x => x.state === thing.state) === i);
    }
    else if (this.searchbranchPlant.length == 0 && this.searchstate.length > 0) {
      let filteredStateList: any = [];
      filteredStateList = this.AMSPricingList.filter(x => { for (const filter of this.searchstate) { if (x.state == filter) { return true; } } });
      this.AMSPricingListDataSource = new MatTableDataSource(filteredStateList);
      this.FilteredData = filteredStateList;
      this.branchPlantData = filteredStateList.filter((thing, i, arr) => arr.findIndex(x => x.branchPlant === thing.branchPlant) === i);
    }
    else {
      this.AMSPricingListDataSource = new MatTableDataSource(this.AMSPricingList);
      this.FilteredData = this.AMSPricingList;
      this.stateData = this.AMSPricingList.filter((thing, i, arr) => arr.findIndex(x => x.state === thing.state) === i);
      this.branchPlantData = this.AMSPricingList.filter((thing, i, arr) => arr.findIndex(x => x.branchPlant === thing.branchPlant) === i);
    }

    this.filteredValues['branchPlant'] = this.searchbranchPlant;
    this.filteredValues['state'] = this.searchstate;
    this.AMSPricingListDataSource.filterPredicate = this.customFilterPredicate();
    this.selectAllForDropdownItemsForBranchPlant(this.FilteredData);
    this.selectAllForDropdownItemsForState(this.FilteredData);
  }

  // Export data from grid data
  onExportBtnClick() {
    this.loaderService.setLoaderStatus(true);

    if (this.FilteredData && this.FilteredData.length > 0) {
      const excelData = [];
      if (this.filteredValues.itemDesc == '' && this.filteredValues.secondItemNumber == '') {
        this.FilteredData.forEach(x => {
          excelData.push(this.setHeaderForExport(x));
        });
      }
      else {
        this.FilteredData.forEach(x => {
          if ((this.filteredValues.secondItemNumber != '' && x.secondItemNumber.indexOf(this.filteredValues.secondItemNumber) > -1)
            && (this.filteredValues.itemDesc != '' && x.itemDesc.indexOf(this.filteredValues.itemDesc) > -1)) {
            excelData.push(this.setHeaderForExport(x));
          }
          else if (this.filteredValues.secondItemNumber == '' && this.filteredValues.itemDesc != '' && x.itemDesc.indexOf(this.filteredValues.itemDesc) > -1) {
            excelData.push(this.setHeaderForExport(x));
          }
          else if (this.filteredValues.itemDesc == '' && this.filteredValues.secondItemNumber != '' && x.secondItemNumber.indexOf(this.filteredValues.secondItemNumber) > -1) {
            excelData.push(this.setHeaderForExport(x));
          }
        });
      }

      setTimeout(x => {
        this.excelService.exportExcel(excelData, 'AMSPricingList');
        this.loaderService.setLoaderStatus(false);
      }, 100);
    }
  }

  setHeaderForExport(data: any) {
    let exportDisplayedColumns = this.originalDisplayedColumns.filter(x => this.displayedColumns.find(y => x.columnfield == y));
    const exportData = new Map();
    exportDisplayedColumns.forEach(col => {
      switch (col.columnfield) {
        case 'state':
          exportData.set(col.headertxt, data.state)
          break;
        case 'branchPlant':
          exportData.set(col.headertxt, data.branchPlant)
          break;
        case 'secondItemNumber':
          exportData.set(col.headertxt, data.secondItemNumber)
          break;
        case 'itemDesc':
          exportData.set(col.headertxt, data.itemDesc)
          break;
        case 'itemDesc2':
          exportData.set(col.headertxt, data.itemDesc2)
          break;
        case 'price':
          exportData.set(col.headertxt, data.price)
          break;
        default: {
          break;
        }
      }
    });

    const obj = this.autoConvertMapToObject(exportData);

    return obj;
  }

  private autoConvertMapToObject = (map) => {
    const obj = {};
    for (const item of [...map]) {
      const [
        key,
        value
      ] = item;
      obj[key] = value;
    }
    return obj;
  }

  selectAllForDropdownItemsForBranchPlant(items: any[]) {
    const allSelect = (items) => {
      items.forEach((element) => {
        element['selectedAllGroupbranchPlant'] = 'selectedAllGroupbranchPlant';
      });
    };

    allSelect(items);
  }

  selectAllForDropdownItemsForState(items: any[]) {
    const allSelect = (items) => {
      items.forEach((element) => {
        element['selectedAllGroupbranchState'] = 'selectedAllGroupbranchState';
      });
    };

    allSelect(items);
  }

  ddlOptionsSearchState = (term: string, item: any) => {
    term = term.toLocaleLowerCase();
    return item['state'].toLocaleLowerCase().indexOf(term) > -1;
  };

  ddlOptionsSearchBranchPlantData = (term: string, item: any) => {
    term = term.toLocaleLowerCase();
    return item['branchPlant'].toLocaleLowerCase().indexOf(term) > -1;
  };

  //Select filter
  public selectFilter() {
    this.setFilter();
    const filters: UserFilterColumnDisplayed = {
      filterOption: this.filteredValues,
      filterValueList: this.filterValueList
    };

    let newFilter = new UserReportFilter();

    newFilter.reportFilter = JSON.stringify(filters);
    var columns = this.originalDisplayedColumns.filter(item => !this.fixedColumn.includes(item.columnfield)).map(x => new ColumnDescription(x.columnfield, x.headertxt));

    this.userReportFilterSliderService.activeSlider(ReportType.AMSPricing, 0, columns, newFilter);
  }

  //Add filter
  public addFilter() {
    this.setFilter();
    const filters: UserFilterColumnDisplayed = {
      filterOption: this.filteredValues,
      filterValueList: this.filterValueList
    };

    let newFilter = new UserReportFilter();
    var columns = this.originalDisplayedColumns.filter(item => !this.fixedColumn.includes(item.columnfield)).map(x => new ColumnDescription(x.columnfield, x.headertxt));
    newFilter.reportFilter = JSON.stringify(filters);

    this.userReportFilterSliderService.activeSlider(ReportType.AMSPricing, 1, columns, newFilter);
  }

  public editFilter() {
    this.setFilter();
    var column = this.originalDisplayedColumns.filter(item => !this.fixedColumn.includes(item.columnfield)).map(x => new ColumnDescription(x.columnfield, x.headertxt));
    const filters: UserFilterColumnDisplayed = {
      filterOption: this.filteredValues,
      filterValueList: this.filterValueList,
      displayedColumns: this.displayedColumns.filter(item => !this.fixedColumn.includes(item)).map(x => this.originalDisplayedColumns.find(y => y.columnfield === x))
    };

    this.currentFilter.reportFilter = JSON.stringify(filters);

    this.userReportFilterSliderService.activeSlider(ReportType.AMSPricing, 1, column, this.currentFilter);
  }

  public save(): void {
    this.setFilter();
    const filters: UserFilterColumnDisplayed = {
      filterOption: this.filteredValues,
      filterValueList: this.filterValueList,
      displayedColumns: this.displayedColumns.filter(item => !this.fixedColumn.includes(item)).map(x => this.originalDisplayedColumns.find(y => y.columnfield === x))
    };

    this.currentFilter.reportFilter = JSON.stringify(filters);

    if (this.currentFilter.userReportFilterId) {
      this.userReportFilterService.updateUserReportFilters(this.currentFilter).subscribe(filter => {
        if (filter) {
          this.toastrService.success("Records saved successfully.");
        }
      });
    }
    else {
      this.userReportFilterService.addUserReportFilters(this.currentFilter).subscribe(filter => {
        if (filter) {
          this.currentFilter.userReportFilterId = filter.userReportFilterId;
          this.toastrService.success("Records saved successfully.");
        }
      });
    }
  }

  setFilter() {
    this.filterValueList = [];
    if (this.filteredValues.branchPlant && this.filteredValues.branchPlant != '') {
      this.filterValueList.push('Branch Plant : ' + this.filteredValues.branchPlant.join());
    }
    if (this.filteredValues.state && this.filteredValues.state != '') {
      this.filterValueList.push('State : ' + this.filteredValues.state.join());
    }
    if (this.filteredValues.secondItemNumber && this.filteredValues.secondItemNumber != '') {
      this.filterValueList.push('Item Number : ' + this.filteredValues.secondItemNumber);
    }
    if (this.filteredValues.itemDesc && this.filteredValues.itemDesc != '') {
      this.filterValueList.push('Item Description : ' + this.filteredValues.itemDesc);
    }
  }

  handleKeyevent(event) {
    if (event.keyCode == 13) {
      return false;
    }
  }

  filterByItemNumber(event) {
    this.filteredValues['secondItemNumber'] = event;
    this.AMSPricingListDataSource.filter = JSON.stringify(this.filteredValues);
  }

  filterByItemDesc(event) {
    this.filteredValues['itemDesc'] = event;
    this.AMSPricingListDataSource.filter = JSON.stringify(this.filteredValues);
  }

  redirectToSubscription() {
    this.router.navigate(['/cpp/report/ams-pricing-manage-subscription']);
  }

  public ngOnDestroy(): void {
    this.subscription.forEach(subscription => subscription.unsubscribe());
    this.userReportFilterSliderService.resetFilter();
  }
}

export interface CppAMSPricingElement {
  secondItemNumber: number;
  itemDesc: string;
}
